import {
    ALL_ADDRESSES_API_BAD_RESPONSE_TYPES,
    AddressesApiBadResponse,
} from '@/types/forms/shared/addressesApi/addressesApiBadResponse';
import { ServiceError } from './serviceError';
import { InverterDataContentSearchByManufacturerAndModuleType } from './content/form/serviceDriven/inverterDataContentSearchByManufacturerAndModuleType';
import { GeneratorDataContentSearchByManufacturerAndModuleType } from './content/form/serviceDriven/generatorDataContentSearchByManufacturerAndModuleType';

export const isServiceError = function (
    arg: ServiceError,
): arg is ServiceError {
    return arg.message !== undefined;
};

export const isAddressesApiBadResponse = function (
    arg: unknown,
): arg is AddressesApiBadResponse {
    if (arg === null || typeof arg !== 'string') {
        return false;
    }

    return (ALL_ADDRESSES_API_BAD_RESPONSE_TYPES as ReadonlyArray<
        string
    >).includes(arg);
};

export const isInverterDataContentSearchByManufacturerAndModuleType = function (
    arg: unknown,
): arg is InverterDataContentSearchByManufacturerAndModuleType {
    return (
        (<InverterDataContentSearchByManufacturerAndModuleType>arg)
            .manufacturerName !== undefined &&
        (<InverterDataContentSearchByManufacturerAndModuleType>arg)
            .moduleType !== undefined
    );
};

export const isGeneratorDataContentSearchByManufacturerAndModuleType = function (
    arg: unknown,
): arg is GeneratorDataContentSearchByManufacturerAndModuleType {
    return (
        (<GeneratorDataContentSearchByManufacturerAndModuleType>arg)
            .manufacturerName !== undefined &&
        (<GeneratorDataContentSearchByManufacturerAndModuleType>arg)
            .moduleType !== undefined
    );
};
